import styled from 'styled-components'

const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  box-sizing: border-box;
  box-shadow: ${({ theme }) => theme.shadows.standard};
  border-radius: 4px;
  margin-bottom: 15px;
`

export default Card
